import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import { colors } from '../../utils';

export const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    paper: {
      padding: theme.spacing(2),
      display: 'flex',
      overflow: 'auto',
      flexDirection: 'column'
    },
    formControl: {
      margin: theme.spacing(1)
    },
    vaccinesCardHeader: {
      paddingBottom: 0,
      paddingTop: 5,
      paddingLeft: 5,
      textAlign: 'center',
      background: colors.defaultGrey
    },
    chartBarsCardHeader: {
      paddingBottom: 0,
      paddingTop: 5,
      paddingLeft: 5,
      background: colors.defaultGrey
    },
    vaccinesCardFooter: {
      justifyContent: 'flex-end'
    },
    vaccineSelect: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    },
    displayNone: {
      display: 'none'
    }
  });
});
